import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import StatsCounter from './components/StatsCounter';

import Reviews from './components/Reviews';
import Gallery from './components/Gallery';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default function App(){
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <Hero />
        <About />
        <Services />
        <StatsCounter/>
       
        <Reviews />
        <Gallery />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
